const _ = require('lodash')

/**
 * IPアドレス形式かチェックする
 * @param value チェック対象となる文字列
 * Returns IPアドレス形式であれば true それ以外は false.
 */
function isIpAddressFormat (value) {
  if (_.isString(value)) {
    return !!value.match(/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/)
  }
  return false
}

/**
 * URLが含まれている場合にaタグで囲む
 * @param value URLが含まれている可能性のある文字列
 * Returns URLをaタグで変換した文字列
 */
const replaceUrlLink = (value) => {
  return value.replace(/https?:\/\/[\w/:%#$&?~.=+-]+/g, match => `<a href="${match}" target="_blank">${match}</a>`)
}

/**
 * アドレスが含まれている場合にaタグで囲む
 * @param value アドレスが含まれている可能性のある文字列
 * Returns アドレスをaタグで変換した文字列
 */
const replaceAddressLink = (value) => {
  return value.replace(/[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/gi, match => `<a href="mailto:${match}" target="_blank">${match}</a>`)
}

const replaceAddressAndUrlLink = (value) => {
  return replaceAddressLink(replaceUrlLink(value))
}

/**
 * 画面を閉じ、開いた元画面（window.opener）が存在する場合はリロードする
 * @param targetWindow 対象のwindowオブジェクト
 */
function closeAndReloadOpener (targetWindow) {
  if (targetWindow.opener) {
    targetWindow.opener.location.reload()
  }
  targetWindow.close()
}

exports.isIpAddressFormat = isIpAddressFormat
exports.replaceAddressAndUrlLink = replaceAddressAndUrlLink
exports.closeAndReloadOpener = closeAndReloadOpener
